import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import { toptaalUserQueryKeys } from "@/api/query-keys/users"
import AvailabilityForm from "@/pages/medewerkers/$userId/beschikbaarheid/AvailabilityForm"
import { createFileRoute, useRouter } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/beschikbaarheid/invullen/")({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const { data } = useCurrentUserSuspenseQuery()
  const key = toptaalUserQueryKeys.detail(Number(data.data.userId))

  const handleNavigateOnSucces = () => {
    router.navigate({
      to: "/profiel/beschikbaarheid",
    })
  }

  return (
    <AvailabilityForm
      userId={Number(data?.data.userId)}
      queryKey={key}
      handleNavigate={handleNavigateOnSucces}
    />
  )
}
